import React from "react";
import { Route, Routes } from "react-router-dom";

import { EsportView } from "./view";

import { EsportArticle } from "./esport-article";

export const EsportController = () => {
    return (
        <Routes>
            <Route path="/:id/:slug/:variant" element={<EsportArticle />} />

            <Route path="/:id/:slug" element={<EsportArticle />} />

            <Route path="/:id" element={<EsportArticle />} />

            <Route path="/" element={<EsportView />} />
        </Routes>
    );
};
